import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import college from "../config/collegeConfig";
import { apiJson } from "../utils/api";

const StudentRegister = () => {
  const [regNo, setRegNo] = useState("");
  const [dob, setDob] = useState("");
  const [message, setMessage] = useState("");
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();
    setMessage("");
    setSuccess(false);

    try {
      const data = await apiJson("/api/register", {
        method: "POST",
        body: JSON.stringify({ applyId: regNo, dateOfBirth: dob }),
      });

      localStorage.setItem("token", data.token);
      localStorage.setItem("student", JSON.stringify(data.student));
      setSuccess(true);
      setMessage("Registration successful! Redirecting...");
      setTimeout(() => navigate("/student"), 1500);
    } catch (err) {
      setMessage(err.message || "Registration failed. Please try again.");
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col items-center justify-center px-4">
      <div className="text-center mb-8">
        {college.logo && (
          <img src={college.logo} alt="College Logo" className="mx-auto mb-2 w-20 h-20 object-contain" />
        )}
        <h1 className="text-xl sm:text-2xl font-bold text-gray-800">{college.name}</h1>
        <p className="text-sm text-gray-500">{college.tagline}</p>
      </div>

      <div className="w-full max-w-md bg-white shadow-md rounded-lg p-6">
        <h2 className="text-lg font-semibold text-gray-700 text-center mb-4">
          New Student Registration
        </h2>
        <p className="text-sm text-gray-500 text-center mb-4">
          Enter your registration number and date of birth from the merit list.
        </p>
        <form onSubmit={handleRegister} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">Registration Number</label>
            <input
              type="text"
              value={regNo}
              onChange={(e) => setRegNo(e.target.value)}
              required
              className="mt-1 block w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring focus:ring-indigo-200"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Date of Birth</label>
            <input
              type="date"
              value={dob}
              onChange={(e) => setDob(e.target.value)}
              required
              className="mt-1 block w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring focus:ring-indigo-200"
            />
          </div>
          <button
            type="submit"
            className="w-full bg-indigo-600 text-white py-2 rounded-md hover:bg-indigo-700 transition"
          >
            Register
          </button>
        </form>

        {message && (
          <p className={`text-sm mt-4 text-center ${success ? "text-green-600" : "text-red-600"}`}>
            {message}
          </p>
        )}

        <p className="text-sm text-gray-500 text-center mt-4">
          Already registered? <Link to="/" className="text-indigo-600 hover:underline">Login here</Link>
        </p>
      </div>
    </div>
  );
};

export default StudentRegister;
